import React, { useState, useEffect, useRef } from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import Header from "components/Header/Header.js";
import Divider from '@material-ui/core/Divider';
import Chip from '@material-ui/core/Chip';
import ReactHtmlParser from 'react-html-parser';
import HourglassEmptyOutlinedIcon from '@material-ui/icons/HourglassEmptyOutlined';
import ScoreOutlinedIcon from '@material-ui/icons/ScoreOutlined';
import FiberNewIcon from '@material-ui/icons/FiberNew';
import Footer from "components/Footer/Footer.js";
import Button from '@material-ui/core/Button';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Typography from '@material-ui/core/Typography';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';

import NavigateBeforeOutlinedIcon from '@material-ui/icons/NavigateBeforeOutlined';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import BeatLoader from "react-spinners/BeatLoader";


import Parallax from "components/Parallax/Parallax.js";
import Axios from "axios";
import Config from "../../../config.js"
import swal from 'sweetalert'
import styles from "assets/jss/material-kit-react/views/mpmJudge.js";
import RefreshRoundedIcon from '@material-ui/icons/RefreshRounded';




const useStyles = makeStyles(styles);

export default function MpmMainPage(props) {
    const classes = useStyles();

    const { ...rest } = props;
    const imageClasses = classNames(
        classes.imgRaised,
        classes.imgRoundedCircle,
        classes.imgFluid
    );
    const [challenges, setChallenges] = React.useState(null);
    const [selectedTeam, setSelectedTeam] = React.useState(null);
    const [answers, setAnswers] = React.useState(null);
    const [scores, setScores] = React.useState(null);
    const [teams, setTeams] = React.useState(null);
    const [state, setState] = React.useState({
        Uiux: '',
        Teamwork: '',
        Idea: '',
        Business: '',
        Source: '',
        Output: '',
        Message: '',

    });
    let [teamLoading, setTeamLoading] = useState(true);
    let [answerLoading, setAnswerLoading] = useState(false);
    let [scoreLoading, setScoreLoading] = useState(false);
    const [value, setValue] = React.useState(0);

    function TabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <Box sx={{ p: 3 }}>
                        <Typography>{children}</Typography>
                    </Box>
                )}
            </div>
        );
    }
    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }
    const handleTabChange = (event, newValue) => {
        setValue(newValue);
    };
    const handleChange = (event) => {
        if (event.target.value == 'true' || event.target.value == 'false')
            setState({ ...state, [event.target.name]: Boolean(event.target.value) });
        else setState({ ...state, [event.target.name]: (event.target.value) });
    };
    const handleTextChange = (event) => {
        state.Message = (event.target.value)
        setState(state);

    };
    var getTeamAnswers = function (team) {
        setAnswerLoading(true)
        Axios.post(Config.api + "Mpm/Admin/GetTeamsAnswers", {
            "ChallengeId": "632776a4cf1f000019007884",
            "TeamId": team._id
        },
            {
                headers: {
                    apikey: Config.apikey,
                    Authorization: "Bearer " + localStorage.getItem('token')

                }
            }).then(async (result) => {
                setAnswers(result.data.data)
                setAnswerLoading(false)
            }).catch((err) => {
                setAnswerLoading(false)
                if (err && err.response && err.response.status && err.response.status === 401) {
                    localStorage.removeItem('token');
                    props.history.push("/SignIn");
                }
                else if (err && err.response && err.response.status && err.response.status === 422)
                    swal("اطلاعات ارسالی نادرست است.");
                else if (err && err.response && err.response.status && err.response.status === 404) {
                    swal("هم اکنون مسابقه ای در جریان نیست.");
                    props.history.push("/Mpm");
                }
                else if (err && err.response && err.response.data && err.response.data.message && err.response.data.message.pr) {
                    swal(err.response.data.message.pr);
                }
                else swal("خطایی رخ داده است.")
            })
    }
    var getScores = function (team) {
        setScoreLoading(true)
        Axios.post(Config.api + "Mpm/Admin/GetScores", {
            "ChallengeId": "632776a4cf1f000019007884",
            "TeamId": team._id
        },
            {
                headers: {
                    apikey: Config.apikey,
                    Authorization: "Bearer " + localStorage.getItem('token')

                }
            }).then(async (result) => {
                setScores(result.data.data)
                setScoreLoading(false)
            }).catch((err) => {
                setScoreLoading(false)
                if (err && err.response && err.response.status && err.response.status === 401) {
                    localStorage.removeItem('token');
                    props.history.push("/SignIn");
                }
                else if (err && err.response && err.response.status && err.response.status === 422)
                    swal("اطلاعات ارسالی نادرست است.");
                else if (err && err.response && err.response.status && err.response.status === 404) {
                    swal("هم اکنون مسابقه ای در جریان نیست.");
                    props.history.push("/Mpm");
                }
                else if (err && err.response && err.response.data && err.response.data.message && err.response.data.message.pr) {
                    // swal(err.response.data.message.pr);
                }
                else swal("خطایی رخ داده است." + err)
            })
    }
    var AddScore = function () {
        var data = {};
        data.ChallengeId = "632776a4cf1f000019007884"
        data.TeamId = selectedTeam._id
        if (state.Business != "")
            data.Business = state.Business
        if (state.Source != "")
            data.Source = state.Source
        if (state.Uiux != "")
            data.Uiux = state.Uiux
        if (state.Output != "")
            data.Output = state.Output
        if (state.Teamwork != "")
            data.Teamwork = state.Teamwork
        if (state.Idea != "")
            data.Idea = state.Idea
        if (state.Message != "")
            data.Message = state.Message
        console.log(data)
        Axios.post(Config.api + "Mpm/Admin/AddScore", data,
            {
                headers: {
                    apikey: Config.apikey,
                    Authorization: "Bearer " + localStorage.getItem('token')

                }
            }).then(async (result) => {
                swal("با موفقیت انجام شد.");
                getScores(selectedTeam)
            }).catch((err) => {
                if (err && err.response && err.response.status && err.response.status === 401) {
                    localStorage.removeItem('token');
                    props.history.push("/SignIn");
                }
                else if (err && err.response && err.response.status && err.response.status === 422)
                    swal("اطلاعات ارسالی نادرست است.");
                else if (err && err.response && err.response.status && err.response.status === 404) {
                    swal("هم اکنون مسابقه ای در جریان نیست.");
                    props.history.push("/Mpm");
                }
                else if (err && err.response && err.response.data && err.response.data.message && err.response.data.message.pr) {
                    swal(err.response.data.message.pr);
                }
                else swal("خطایی رخ داده است." + err)
            })
    }
    var selectTeam = function (team) {
        setSelectedTeam(team)
        getTeamAnswers(team)
        getScores(team)
    }
    var refreshClick = function () {
        getScores(selectedTeam)
    }
    useEffect(() => {
        Axios.post(Config.api + "Mpm/Admin/GetChallenge", {
            "ChallengeId": "632776a4cf1f000019007884"
        },
            {
                headers: {
                    apikey: Config.apikey,
                    Authorization: "Bearer " + localStorage.getItem('token')

                }
            }).then(async (result) => {
                setChallenges(result.data.data)
            }).catch((err) => {
                if (err && err.response && err.response.status && err.response.status === 401) {
                    localStorage.removeItem('token');
                    props.history.push("/SignIn");
                }
                else if (err && err.response && err.response.status && err.response.status === 422)
                    swal("اطلاعات ارسالی نادرست است.");
                else if (err && err.response && err.response.status && err.response.status === 404) {
                    swal("هم اکنون مسابقه ای در جریان نیست.");
                    props.history.push("/Mpm");
                }
                else if (err && err.response && err.response.data && err.response.data.message && err.response.data.message.pr) {
                    swal(err.response.data.message.pr);
                }
                else swal("خطایی رخ داده است.")
            })
    }, [])
    useEffect(() => {
        setTeamLoading(true)
        Axios.post(Config.api + "Mpm/Admin/GetTeams", {
            "ChallengeId": "632776a4cf1f000019007884"
        },
            {
                headers: {
                    apikey: Config.apikey,
                    Authorization: "Bearer " + localStorage.getItem('token')

                }
            }).then(async (result) => {
                setTeams(result.data.data)
                setTeamLoading(false)
            }).catch((err) => {
                setTeamLoading(false)
                if (err && err.response && err.response.status && err.response.status === 401) {
                    localStorage.removeItem('token');
                    props.history.push("/SignIn");
                }
                else if (err && err.response && err.response.status && err.response.status === 422)
                    swal("اطلاعات ارسالی نادرست است.");
                else if (err && err.response && err.response.status && err.response.status === 404) {
                    swal("هم اکنون مسابقه ای در جریان نیست.");
                    props.history.push("/Mpm");
                }
                else if (err && err.response && err.response.data && err.response.data.message && err.response.data.message.pr) {
                    swal(err.response.data.message.pr);
                }
                else swal("خطایی رخ داده است.")
            })
    }, [])

    return (
        <div>
            <Header
                color="transparent"
                brand="Material Kit React"
                rightLinks={<HeaderLinks />}
                fixed
                changeColorOnScroll={{
                    height: 80,
                    color: "white"
                }}
                {...rest}
            />
            <Parallax small filter image={require("assets/img/bg11.jpg")} />
            <div className={classNames(classes.main, classes.minMainRaised)}>
                <div>
                    <div className={classes.container}>
                        <GridContainer justify="center" >
                            <GridItem xs={12} sm={12} md={12}>
                                <h3 className={classes.title + " " + classes.center + " " + classes.fullWidth}>
                                    {
                                        (
                                            () => {
                                                if (challenges) return "داوری ماراتن ملی موبایل ایران"
                                            }
                                        )()

                                    }
                                </h3>
                            </GridItem>
                        </GridContainer>
                        <GridContainer>
                            <GridItem xs={12} sm={12} md={3}>
                                <div className={classes.menu}>
                                    <div className={classes.rightBox}>
                                        <Card className={classes.root} variant="outlined">
                                            <CardContent>
                                                <Typography className={classes.title} color="textSecondary" gutterBottom>
                                                    تیم‌ها
                                                </Typography>
                                                <div className={classes.center + " " + classes.fastAccess}>
                                                    <BeatLoader loading={teamLoading} color={"gray"} size={15} />
                                                </div>
                                                <div className={classes.scroll}>
                                                    <List component="nav">
                                                        {teams && teams.map((item, index) => {
                                                            return (
                                                                <ListItem
                                                                    button
                                                                    onClick={() => {
                                                                        selectTeam(item)
                                                                    }}
                                                                >
                                                                    <ListItemIcon>
                                                                        <NavigateBeforeOutlinedIcon />
                                                                    </ListItemIcon>
                                                                    <ListItemText className={classes.listitem} primary={item.name} />
                                                                </ListItem>
                                                            )
                                                        })
                                                        }
                                                    </List>
                                                </div>
                                            </CardContent>
                                            <CardActions>
                                            </CardActions>
                                        </Card>
                                    </div>
                                </div>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={9}>

                                {(() => {

                                    if (selectedTeam)
                                        return (
                                            <div>
                                                <div className={classes.menu}>
                                                    <b>تیم {selectedTeam.name}</b>
                                                </div>
                                                <Box sx={{ width: '100%' }}>
                                                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                                        <Tabs value={value} onChange={handleTabChange} aria-label="basic tabs example">
                                                            <Tab label="امتیازات" {...a11yProps(0)} />
                                                            <Tab label="پاسخ ها" {...a11yProps(1)} />
                                                        </Tabs>
                                                    </Box>
                                                    <TabPanel value={value} index={0}>
                                                        <div className={classes.menu}>
                                                            <Card className={classes.root} elevation={0}>
                                                                <CardContent>
                                                                    <div className={classes.center + " " + classes.fastAccess}>
                                                                        <BeatLoader loading={scoreLoading} color={"gray"} size={15} />
                                                                    </div>
                                                                    <TableContainer>
                                                                        <Table className={classes.scoreTable} sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                                                                            <TableHead>
                                                                                <TableRow>
                                                                                    <TableCell>نام</TableCell>
                                                                                    <TableCell align="left">UIUX</TableCell>
                                                                                    <TableCell align="left">کد</TableCell>
                                                                                    <TableCell align="left">کسب و کار</TableCell>
                                                                                    <TableCell align="left">کارتیمی</TableCell>
                                                                                    <TableCell align="left">ایده</TableCell>
                                                                                    <TableCell align="left">خروجی</TableCell>
                                                                                    <TableCell align="left">توضیح</TableCell>
                                                                                </TableRow>
                                                                            </TableHead>
                                                                            <TableBody>
                                                                                {scores && scores.map((item, index) => {
                                                                                    console.log(item)
                                                                                    return (
                                                                                        <TableRow
                                                                                            key={item._id}
                                                                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                                                            <TableCell align="left">{item.refereeName}</TableCell>
                                                                                            <TableCell align="left">{item.uiux}</TableCell>
                                                                                            <TableCell align="left">{item.source}</TableCell>
                                                                                            <TableCell align="left">{item.business}</TableCell>
                                                                                            <TableCell align="left">{item.teamwork}</TableCell>
                                                                                            <TableCell align="left">{item.idea}</TableCell>
                                                                                            <TableCell align="left">{item.output}</TableCell>
                                                                                            <TableCell align="left">{item.message}</TableCell>
                                                                                        </TableRow>
                                                                                    )
                                                                                })
                                                                                }
                                                                            </TableBody>
                                                                        </Table>
                                                                    </TableContainer>
                                                                    <br />
                                                                    <div className={classes.center}>

                                                                        <Button onClick={refreshClick} size="small" color="textSecondary">
                                                                            <RefreshRoundedIcon />
                                                                        </Button>
                                                                    </div>
                                                                    <p className={classes.divider} ></p>
                                                                    <br />
                                                                    <br />
                                                                    لطفا امتیازتان به این تیم را وارد کنید. امتیازات از 1 تا 10 هستند، 1 بسیار ضعیف، 10 عالی.
                                                                    <br />
                                                                    شما باید بتوانید در پس از ثبت امتیاز، آن را در لیست بالا ببینید.
                                                                    <br />
                                                                    <div>
                                                                        <FormControl className={classes.selectControl}>
                                                                            <InputLabel htmlFor="Uiux">UI/UX</InputLabel>
                                                                            <Select
                                                                                onChange={handleChange}
                                                                                defaultValue=''
                                                                                value={state.Uiux}
                                                                                inputProps={{
                                                                                    name: 'Uiux',
                                                                                    id: 'Uiux',
                                                                                }}
                                                                            >
                                                                                <MenuItem value="">
                                                                                    <em>انتخاب کنید</em>
                                                                                </MenuItem>
                                                                                {[10, 9, 8, 7, 6, 5, 4, 3, 2, 1].map((item, index) => {
                                                                                    return (<MenuItem value={item}>{item}</MenuItem>)
                                                                                })}
                                                                            </Select>
                                                                        </FormControl>
                                                                        <FormControl className={classes.selectControl}>
                                                                            <InputLabel htmlFor="Source">کد</InputLabel>
                                                                            <Select
                                                                                onChange={handleChange}
                                                                                defaultValue=''
                                                                                value={state.Source}
                                                                                inputProps={{
                                                                                    name: 'Source',
                                                                                    id: 'Source',
                                                                                }}
                                                                            >
                                                                                <MenuItem value="">
                                                                                    <em>انتخاب کنید</em>
                                                                                </MenuItem>
                                                                                {[10, 9, 8, 7, 6, 5, 4, 3, 2, 1].map((item, index) => {
                                                                                    return (<MenuItem value={item}>{item}</MenuItem>)
                                                                                })}
                                                                            </Select>
                                                                        </FormControl>
                                                                        <FormControl className={classes.selectControl}>
                                                                            <InputLabel htmlFor="Business">کسب و کار</InputLabel>
                                                                            <Select
                                                                                onChange={handleChange}
                                                                                value={state.Business}
                                                                                defaultValue=''
                                                                                inputProps={{
                                                                                    name: 'Business',
                                                                                    id: 'Business',
                                                                                }}
                                                                            >
                                                                                <MenuItem value="">
                                                                                    <em>انتخاب کنید</em>
                                                                                </MenuItem>
                                                                                {[10, 9, 8, 7, 6, 5, 4, 3, 2, 1].map((item, index) => {
                                                                                    return (<MenuItem value={item}>{item}</MenuItem>)
                                                                                })}
                                                                            </Select>
                                                                        </FormControl>
                                                                        <FormControl className={classes.selectControl}>
                                                                            <InputLabel htmlFor="Teamwork">کارتیمی</InputLabel>
                                                                            <Select
                                                                                onChange={handleChange}
                                                                                defaultValue=''
                                                                                value={state.Teamwork}
                                                                                inputProps={{
                                                                                    name: 'Teamwork',
                                                                                    id: 'Teamwork',
                                                                                }}
                                                                            >
                                                                                <MenuItem value="">
                                                                                    <em>انتخاب کنید</em>
                                                                                </MenuItem>
                                                                                {[10, 9, 8, 7, 6, 5, 4, 3, 2, 1].map((item, index) => {
                                                                                    return (<MenuItem value={item}>{item}</MenuItem>)
                                                                                })}
                                                                            </Select>
                                                                        </FormControl>
                                                                        <FormControl className={classes.selectControl}>
                                                                            <InputLabel htmlFor="Idea">ایده</InputLabel>
                                                                            <Select
                                                                                onChange={handleChange}
                                                                                defaultValue=''
                                                                                value={state.Idea}
                                                                                inputProps={{
                                                                                    name: 'Idea',
                                                                                    id: 'Idea',
                                                                                }}
                                                                            >
                                                                                <MenuItem value="">
                                                                                    <em>انتخاب کنید</em>
                                                                                </MenuItem>
                                                                                {[10, 9, 8, 7, 6, 5, 4, 3, 2, 1].map((item, index) => {
                                                                                    return (<MenuItem value={item}>{item}</MenuItem>)
                                                                                })}
                                                                            </Select>
                                                                        </FormControl>
                                                                        <FormControl className={classes.selectControl}>
                                                                            <InputLabel htmlFor="Output">خروجی</InputLabel>
                                                                            <Select
                                                                                onChange={handleChange}
                                                                                defaultValue=''
                                                                                value={state.Output}
                                                                                inputProps={{
                                                                                    name: 'Output',
                                                                                    id: 'Output',
                                                                                }}
                                                                            >
                                                                                <MenuItem value="">
                                                                                    <em>انتخاب کنید</em>
                                                                                </MenuItem>
                                                                                {[10, 9, 8, 7, 6, 5, 4, 3, 2, 1].map((item, index) => {
                                                                                    return (<MenuItem value={item}>{item}</MenuItem>)
                                                                                })}
                                                                            </Select>
                                                                        </FormControl>
                                                                        <br />
                                                                        <br />
                                                                        <FormControl fullWidth variant="standard">
                                                                            <InputLabel htmlFor="Message">توضیحات</InputLabel>
                                                                            <Input
                                                                                onChange={handleTextChange}

                                                                                name="Message"
                                                                            />
                                                                        </FormControl>
                                                                        <p className={classes.divider} ></p>

                                                                        <div className={classes.center}>
                                                                            <Button variant="contained" color="primary" disableElevation onClick={AddScore}>
                                                                                ذخیره سازی
                                                                            </Button>
                                                                        </div>
                                                                    </div>
                                                                </CardContent>
                                                                <CardActions>
                                                                </CardActions>
                                                            </Card>
                                                        </div>
                                                    </TabPanel>
                                                    <TabPanel value={value} index={1}>
                                                        <div className={classes.menu}>
                                                            <div className={classes.center + " " + classes.fastAccess}>
                                                                <BeatLoader loading={answerLoading} color={"gray"} size={15} />
                                                            </div>
                                                            {answers && answers.map((item, index) => {
                                                                var question = challenges[0].questions.filter((question) => {
                                                                    if (question._id == item.question)
                                                                        return question;
                                                                })[0];
                                                                if (item.answerType == 'yesno') {
                                                                    return (
                                                                        <div>
                                                                            <div className={classes.question}>
                                                                                <div className={classes.questionTitle}>{question.title}</div>
                                                                                <div className={classes.description}>{ReactHtmlParser(question.description)}</div>
                                                                                <div className={classes.answerTitle}>پاسخ:</div>
                                                                                <div className={classes.answer}>{item.description == "yes" ? "بله" : (item.description == "no" ? "no" : "")}</div>
                                                                            </div>
                                                                            <Divider className={classes.divider} />
                                                                        </div>
                                                                    )
                                                                } else if (item.answerType == 'text') {
                                                                    return (
                                                                        <div>
                                                                            <div className={classes.question}>
                                                                                <div className={classes.questionTitle}>{question.title}</div>
                                                                                <div className={classes.description}>{ReactHtmlParser(question.description)}</div>
                                                                                <div className={classes.answerTitle}>پاسخ:</div>
                                                                                <div className={classes.answer}>{item.description}</div>
                                                                            </div>
                                                                            <Divider className={classes.divider} />
                                                                        </div>
                                                                    )
                                                                }
                                                                else if (item.answerType == 'git') {
                                                                    return (
                                                                        <div>
                                                                            <div className={classes.question}>
                                                                                <div className={classes.questionTitle}>{question.title}</div>
                                                                                <div className={classes.description}>{ReactHtmlParser(question.description)}</div>
                                                                                <div className={classes.answerTitle}>پاسخ:</div>
                                                                                <div className={classes.answer}>{item.description}</div>
                                                                                <div className={classes.answer}><a target="_blank" href={item.value}>{item.value}</a></div>
                                                                            </div>
                                                                            <Divider className={classes.divider} />
                                                                        </div>
                                                                    )
                                                                }
                                                            })
                                                            }
                                                        </div>
                                                    </TabPanel>
                                                </Box>
                                            </div>
                                        )
                                })()
                                }
                            </GridItem>
                        </GridContainer>
                        <br />
                        <br />
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
